/*!
 * @license
 * SPDX-License-Identifier: LicenseRef-cloudEQ-Proprietary
 * Copyright (c) 2026-present cloudEQ Inc. All Rights Reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL.
 *
 * This source code, including all associated files, documentation, and
 * compiled forms, is the exclusive property of cloudEQ Inc. and is
 * protected by copyright, trade secret, and other intellectual property laws.
 *
 * This software is licensed, not sold, solely for use by authorized
 * licensees under the terms of a written license agreement with
 * cloudEQ Inc. Unless expressly permitted by that agreement, you may not
 * copy, modify, merge, distribute, sublicense, sell, publish, reverse
 * engineer, decompile, disassemble, or create derivative works of this
 * software, in whole or in part, by any means.
 *
 * Access to this file does not grant any license or right to use it.
 * Unauthorized use, reproduction, or disclosure is strictly prohibited and
 * may result in civil and criminal penalties.
 *
 * Contact: legal@cloudeq.com
 */

/**
 * Nobody has added this person to a circle yet.
 *
 * **It replaces every view, not just the board** — `access-view` walks list,
 * calendar, archived and board and requires the same message on each, "so no tab
 * is a way around it". It lived inside `BoardView` at first, which meant the
 * other four rendered an empty list, an empty calendar and an empty archive: four
 * screens saying "there is no work" to somebody whose actual situation is "you
 * cannot see any work". Those are opposite statements.
 *
 * It names who to ask, because the person reading it cannot fix it themselves,
 * and a dead end with no next step is what makes an access problem feel like a
 * broken app.
 */
export function NoCircle() {
  return (
    <div className="no-circle mx-auto max-w-md px-5 py-16 text-center">
      <div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-full bg-action-bg text-action">
        <svg viewBox="0 0 24 24" className="size-6" fill="none" stroke="currentColor" strokeWidth={2}>
          <circle cx="12" cy="12" r="9" />
          <path d="M8 15c1.2-1.3 2.5-2 4-2s2.8.7 4 2" />
          <circle cx="9.5" cy="10" r="1" />
          <circle cx="14.5" cy="10" r="1" />
        </svg>
      </div>
      <h2 className="m-0 text-lg font-semibold">You have not been assigned to any circle</h2>
      <p className="mt-2 mb-0 text-sm leading-relaxed text-ink-muted">
        You do not yet have access to any board on Qollab. Please contact{' '}
        <strong>Nishant Johar</strong> to be added to a circle.
      </p>
    </div>
  );
}
